import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "checkbox-tick-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.0176 9.88189C16.3105 9.589 16.3105 9.11413 16.0176 8.82123C15.7248 8.52834 15.2499 8.52834 14.957 8.82123L10.5963 13.1819L8.97271 11.5584C8.67982 11.2655 8.20495 11.2655 7.91205 11.5584C7.61916 11.8513 7.61916 12.3261 7.91205 12.619L10.0659 14.7729L10.08 14.7869C10.3728 15.0798 10.8477 15.0798 11.1406 14.7869C11.1824 14.7451 11.2183 14.6996 11.2482 14.6514L16.0176 9.88189Z"
    }, null, -1)
  ])))
}
export default { render: render }